module.exports = __webpack_public_path__ + "img/skeleton_king.c4f4541d.png";